{
  "commonHeader": {
    "toggleSidebar": "サイドバーを切り替え",
    "cartLoading": "ショッピングカートを読み込み中",
    "cart": "ショッピングカート",
    "aicForAdmin": {
      "ariaLabel": "管理者向けAI"
    },
    "usersResults": "ユーザー、{0}件の結果",
    "settingsResults": "設定、{0}件の結果",
    "navigationResults": "ナビゲーション、{0}件の結果",
    "learnMoreAbout": "{0}の詳細",
    "close": "閉じる",
    "products": "製品",
    "moreActions": "その他の操作",
    "search": "検索",
    "searchPlaceholderAll": "ユーザー、アカウント設定、またはナビゲーションを検索",
    "searchPlaceholderUsers": "ユーザーまたはナビゲーションを検索",
    "searchPlaceholderSettings": "アカウント設定またはナビゲーションを検索",
    "searchPlaceholderNav": "ナビゲーションを検索"
  },
  "footerCopyright": {
    "language": "言語 {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "管理者メニュー"
    }
  },
  "shared": {
    "close": "閉じる",
    "sideMenu": {
      "personalAria": "個人メニュー",
      "adminAria": "管理者メニュー",
      "mainNav": "メインナビゲーション",
      "submenu": "サブメニュー",
      "pinnedSection": "{0}をピン留め済み",
      "sideMenuAria": "サイドメニュー",
      "pinItem": "{0}をピン留め",
      "unpinItem": "{0}のピン留めを解除",
      "reorderGrabbed": "{0}を並べ替え中、つかんでいます。上下矢印キーで移動し、スペースまたはEnterでドロップ、Escでキャンセルします。",
      "reorderIdle": "{0}を並べ替えます。スペースまたはEnterでつかみます。",
      "hintHandlePin": "Tabキーを押してドラッグハンドルとピン留めボタンにアクセス",
      "hintHandle": "Tabキーを押してドラッグハンドルにアクセス",
      "hintPin": "Tabキーを押してピン留めボタンにアクセス",
      "upgradeToPro": "Proにアップグレード"
    },
    "item": "項目"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "新しいエクスペリエンスを試す"
    }
  },
  "aicGuide": {
    "common": {
      "close": "閉じる"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "ディビジョンが利用可能になりました"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "外部アカウントを管理"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "アドレス帳は顧客ディレクトリに名称変更されます"
    }
  },
  "feedback": {
    "itemLableForProductArea": "プロダクト領域",
    "itemLableForFeedback": "フィードバック"
  }
}
